module.exports = __webpack_public_path__ + "static/music@large-2d550dffdf6925823621e52b6091c0d0.jpg";